/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * FastMile API
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  ProblemDetails,
  SubscriptionTierDtoApiResponse,
  SubscriptionTierDtoListApiResponse,
} from '../../models/generated'

import { fastmileInstance } from '../../fastmileInstance'

export const getApiSubscriptionTier = (signal?: AbortSignal) => {
  return fastmileInstance<SubscriptionTierDtoListApiResponse>({
    url: '/api/SubscriptionTier',
    method: 'GET',
    signal,
  })
}

export const getGetApiSubscriptionTierQueryKey = () => {
  return ['/api/SubscriptionTier'] as const
}

export const getGetApiSubscriptionTierQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError = unknown,
>(options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiSubscriptionTier>>,
    TError,
    TData
    >
    >;
  }) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSubscriptionTierQueryKey()

  const queryFn: QueryFunction<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>
  > = ({ signal }) => getApiSubscriptionTier(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError,
  TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSubscriptionTierQueryResult = NonNullable<
Awaited<ReturnType<typeof getApiSubscriptionTier>>
>
export type GetApiSubscriptionTierQueryError = unknown

export function useGetApiSubscriptionTier<
  TData = Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError = unknown,
>(options: {
  query: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError,
  TData
  >
  > &
  Pick<
  DefinedInitialDataOptions<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError,
  Awaited<ReturnType<typeof getApiSubscriptionTier>>
  >,
  'initialData'
  >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiSubscriptionTier<
  TData = Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError = unknown,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError,
  TData
  >
  > &
  Pick<
  UndefinedInitialDataOptions<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError,
  Awaited<ReturnType<typeof getApiSubscriptionTier>>
  >,
  'initialData'
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiSubscriptionTier<
  TData = Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError = unknown,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError,
  TData
  >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}

export function useGetApiSubscriptionTier<
  TData = Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError = unknown,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionTier>>,
  TError,
  TData
  >
  >;
}): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } {
  const queryOptions = getGetApiSubscriptionTierQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getApiSubscriptionTierForVehicleCountVehicleCount = (
  vehicleCount: number,
  signal?: AbortSignal,
) => {
  return fastmileInstance<SubscriptionTierDtoApiResponse>({
    url: `/api/SubscriptionTier/for-vehicle-count/${vehicleCount}`,
    method: 'GET',
    signal,
  })
}

export const getGetApiSubscriptionTierForVehicleCountVehicleCountQueryKey = (
  vehicleCount: number,
) => {
  return [`/api/SubscriptionTier/for-vehicle-count/${vehicleCount}`] as const
}

export const getGetApiSubscriptionTierForVehicleCountVehicleCountQueryOptions =
  <
    TData = Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError = ProblemDetails,
  >(
    vehicleCount: number,
    options?: {
      query?: Partial<
      UseQueryOptions<
      Awaited<
      ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
      >,
      TError,
      TData
      >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiSubscriptionTierForVehicleCountVehicleCountQueryKey(
        vehicleCount,
      )

    const queryFn: QueryFunction<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >
    > = ({ signal }) =>
      getApiSubscriptionTierForVehicleCountVehicleCount(vehicleCount, signal)

    return {
      queryKey,
      queryFn,
      enabled: !!vehicleCount,
      ...queryOptions,
    } as UseQueryOptions<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError,
    TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
  }

export type GetApiSubscriptionTierForVehicleCountVehicleCountQueryResult =
  NonNullable<
  Awaited<
  ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
  >
  >
export type GetApiSubscriptionTierForVehicleCountVehicleCountQueryError =
  ProblemDetails

export function useGetApiSubscriptionTierForVehicleCountVehicleCount<
  TData = Awaited<
  ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
  >,
  TError = ProblemDetails,
>(
  vehicleCount: number,
  options: {
    query: Partial<
    UseQueryOptions<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError,
    TData
    >
    > &
    Pick<
    DefinedInitialDataOptions<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError,
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >
    >,
    'initialData'
    >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiSubscriptionTierForVehicleCountVehicleCount<
  TData = Awaited<
  ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
  >,
  TError = ProblemDetails,
>(
  vehicleCount: number,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError,
    TData
    >
    > &
    Pick<
    UndefinedInitialDataOptions<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError,
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >
    >,
    'initialData'
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiSubscriptionTierForVehicleCountVehicleCount<
  TData = Awaited<
  ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
  >,
  TError = ProblemDetails,
>(
  vehicleCount: number,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError,
    TData
    >
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}

export function useGetApiSubscriptionTierForVehicleCountVehicleCount<
  TData = Awaited<
  ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
  >,
  TError = ProblemDetails,
>(
  vehicleCount: number,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<
    ReturnType<typeof getApiSubscriptionTierForVehicleCountVehicleCount>
    >,
    TError,
    TData
    >
    >;
  },
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } {
  const queryOptions =
    getGetApiSubscriptionTierForVehicleCountVehicleCountQueryOptions(
      vehicleCount,
      options,
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  }

  query.queryKey = queryOptions.queryKey

  return query
}
